import ContasACadastrarService from "../../../services/http/services/SaldoDeContas/ContasACadastrarService";

export const getQuantidadesContasACadastrarSaldoDeContas = async () => {
    try {
        const response = await ContasACadastrarService.getQuantidadeContasACadastrar();
        return response;
    } catch (error: any) {
        return null;
    }
};
